import React from "react";
import "../styles.css";
type RiskBand = {
  label: string;
  min: number;
  max: number;
  color: string;
  background: string;
};

const RISK_BANDS: RiskBand[] = [
  {
    label: "Very Low Risk",
    min: 711,
    max: 850,
    color: "#2ECC71",
    background: "#E8F9F0",
  },
  {
    label: "Low Risk",
    min: 671,
    max: 710,
    color: "#1ABC9C",
    background: "#E6FAF7",
  },
  {
    label: "Medium Risk",
    min: 591,
    max: 670,
    color: "#F1C40F",
    background: "#FFF8D9",
  },
  {
    label: "High Risk",
    min: 531,
    max: 590,
    color: "#E67E22",
    background: "#FFF2E6",
  },
  {
    label: "Very High Risk",
    min: 300,
    max: 530,
    color: "#C0392B",
    background: "#FDECEC",
  },
  {
    label: "Very High Risk",
    min: 1,
    max: 300,
    color: "#C0392B",
    background: "#FDECEC",
  },
  {
    label: "No score",
    min: 0,
    max: 0,
    color: "#7F8C8D",
    background: "#F2F4F5",
  },
];

const NO_SCORE_BAND: RiskBand = {
  label: "No score",
  min: 0,
  max: 0,
  color: "#7F8C8D",
  background: "#F2F4F5",
};

function getRiskType(score: number | null | undefined): RiskBand {
  if (!score || score === 0) return NO_SCORE_BAND;

  const band = RISK_BANDS.find(({ min, max }) => score >= min && score <= max);

  return band ? band : NO_SCORE_BAND;
}

interface RiskScoreProps {
  score: number | null;
}

const RiskScoreStrip: React.FC<RiskScoreProps> = ({ score }) => {
  const riskType = getRiskType(score ?? 0);

  return (
    <div className="risk-strip">
      <div className="risk-strip__score">
        <span className="risk-strip__label">Score :</span>
        <span
          className="risk-strip__score-value"
          style={{ color: riskType.color }}
        >
          {score ?? 0}
        </span>
      </div>

      <div className="risk-strip__type">
        <span className="risk-strip__label">Risk Type</span>
        {/* <span className="risk-strip__badge" style={{}}>{riskType}</span> */}
        <span
          style={{
            color: riskType.color,
            background: riskType.background,
            padding: "8px 15px",
            borderRadius: "999px",
            fontSize: "16px",
            fontWeight: 400,
          }}
        >
          {riskType.label}
        </span>
      </div>
    </div>
  );
};

export default RiskScoreStrip;
